import { Typography } from '@mui/material';

interface PageProps extends React.PropsWithChildren {
  title?: string;
}

const Page: React.FC<PageProps> = (props) => {
  return (
    <div style={{ margin: '30px 40px' }}>
      {props.title && (
        <Typography variant='p50Light' color='secondary.main'>
          {props.title}
        </Typography>
      )}
      {props.children}
    </div>
  );
};

export default Page;
